export { default, StyledHTML } from './HTML';
export type { HTMLProps } from './HTML';
